import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthGuard, AuthService } from '@auth0/auth0-angular';
import { InviteApiController } from '../api-controllers/invite.api-controller';
import { OrganizationManager } from '../managers/organization.manager';
import { LoggingService } from '../../../../modules/src/lib/core/services/logging.service';
import { BillingManager } from '../managers/billing.manager';
import { OrganizationLicenseStatusEnum } from '../enums/organization-license-status.enum';

@Injectable()
export class HasNoActivatedLicenseGuard implements CanActivate {
  constructor(private readonly authService: AuthService,
              private readonly authGuard: AuthGuard,
              private readonly router: Router,
              private readonly inviteApiController: InviteApiController,
              private readonly organizationManager: OrganizationManager,
              private readonly loggingService: LoggingService,
              private readonly billingManager: BillingManager,
  ) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
    return new Promise((resolve, reject) => {
      // If you are not logged-in, redirect to login
      this.authGuard.canActivate(route, state).subscribe(async isAuthenticated => {
        if (isAuthenticated === false) {
          this.loggingService.debug('[Guard:\'has-activated-license\'] - User is not authenticated, therefore we determine that user doesn\'t have org and redirect to /login.');
          return resolve(this.router.parseUrl('/login'));
        }

        const licenseStatus = await this.billingManager.getLicenseStatus();
        if (licenseStatus === OrganizationLicenseStatusEnum.Unlicensed) {
          return resolve(true);
        }

        return resolve(this.router.parseUrl('/'));
      });
    });
  }
}
